import React from "react";
import "./TenantGoodbyePage.css";
import { GetImages } from "../../../utils/GetImages"; // Assuming we can use a generic nice image or logo

interface TenantGoodbyePageProps {
  tenantName?: string;
  onLogout: () => void;
}

const TenantGoodbyePage: React.FC<TenantGoodbyePageProps> = ({ tenantName, onLogout }) => {
  return (
    <div className="tenant-goodbye-container">
      <div className="tenant-goodbye-card">
        <div className="goodbye-icon-wrapper">
           {/* We can use a checkmark or a home icon here. using a placeholder svg for now if GetImages doesn't have a perfect match, or reusing the logo */}
           <div className="goodbye-icon">👋</div>
        </div>
        <h1 className="goodbye-title">Thank You!</h1>
        <p className="goodbye-message">
          {tenantName ? `Dear ${tenantName}, ` : ""}
          It has been a pleasure having you. Thank you for staying with us!
        </p>
        <p className="goodbye-subtext">
          Your lease has ended.
        </p>
        
        <button className="goodbye-logout-btn" onClick={onLogout}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default TenantGoodbyePage;
